import { render, staticRenderFns } from "./AuditInfoBaike.vue?vue&type=template&id=0a6fb087&scoped=true"
import script from "./AuditInfoBaike.vue?vue&type=script&lang=js"
export * from "./AuditInfoBaike.vue?vue&type=script&lang=js"
import style0 from "./AuditInfoBaike.vue?vue&type=style&index=0&id=0a6fb087&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6fb087",
  null
  
)

export default component.exports